<template>
  <div class="col-md-4">
    <div class="content-sidebar accordion" id="accordion">

      <!-- sort by ... -->
      <div class="form-group form-inline">
        <label for="sort">Sort by &nbsp;</label>
        <select id="sort" v-model="sortMethod" @change="sort"
                class="form-select">
          <option value="dateAndKind">Date and Kind</option>
          <option value="kindAndDate">Kind and Date</option>
        </select>
      </div>

      <div class="form-group form-inline import-actions">
        <button
          type="button"
          class="btn btn-sm me-2"
          :class="selectedDiagnoses.length === 0 ? 'btn-secondary' : 'btn-primary'"
          @click.prevent="importSelectedDiagnoses"
          :disabled="selectedDiagnoses.length === 0"
        >
          Move selected diagnoses to Current
        </button>
        <button
          type="button"
          class="btn btn-sm"
          :class="selectedMedications.length === 0 ? 'btn-secondary' : 'btn-primary'"
          @click.prevent="importSelectedMedications"
          :disabled="selectedMedications.length === 0"
        >
          Move selected medications to Current
        </button>
      </div>

      <!-- Two levels of heading, 1 and 2,  with corresponding nested loops. -->
      <template v-for="(category, index1) in categories">
        <div v-if="cdaSideBarContentByKindAndDate && cdaSideBarContentByKindAndDate.hasOwnProperty(category)" :key="getHeaderByKind(category)" class="card-top">
        <!-- <div v-for="(content1, key1, index1) in contents || cdaSideBarContentByKindAndDate"
           :key="getHeaderByKind(key1, content1, index1)" > -->
        <div v-if="Object.keys(cdaSideBarContentByKindAndDate[category]).length > 0" class="card">
          <!-- date header -->
          <div class="card-header" :id="category">
              <togglable-caret-header
                class="header__link"
                :data-bs-target="'#collapse'+index1"
                :showCaret="true"
                :collapse-disabled="expanded">

                <a role="button" ref='"toggle-head:"+category'>
                  {{ getHeaderByKind(category) }}      <!-- either date or kind -->
                </a>
                <!-- top name of dropdown -->
                <!-- <watch-button-cda :measKind="key1" :items="content1"/> -->
              </togglable-caret-header>
              <watch-button-cda :measKind="category" :items="cdaSideBarContentByKindAndDate[category]"/>
          </div>
          
          <!-- list of items, e.g. procs, meas, diags -->
          <div :id="'collapse'+index1" :class="'collapse'+(expanded?' show':'')" ref="toggle-target'+index1">
            <div class="card-body">
              <ul class="list-group w-100">
                <!-- CDA grouped by date and kind -->
                <li v-for="(content2, key2) in cdaSideBarContentByKindAndDate[category]" :key="getHeaderByKind(key2)" ref='list-group-item' class="list-group-item">

                  <ul class="list-group w-100">

                    <li class="kind">{{ getHeaderByKind(key2) }}</li>   
                    <li v-for="item in content2" :key="item.kind+item.id" class="list-group-item">
                      <cda-visitable-item 
                        :item="item"
                        @selection-changed-event='onSelectionChanged'
                        @toggle-cda-selection="onToggleSelection"
                      />
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>

        </div>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import types from '@/data/types';
import TogglableCaretHeader from '@/components/includes/TogglableCaretHeader';
import CdaVisitableItem from '@/components/includes/cda/CdaVisitableItem';
import WatchButtonCda from '@/components/private-layouts/_partials/watch/WatchButtonCda'
import kinds from '@/constants/kinds';
import {
  getHeaderByKind
} from '@/data/getters';
import { mapGetters } from 'vuex';
import axios from 'axios';
import { CURR_API } from '@/constants/apis';
import { PRIVILEGES } from '@/constants/privileges';
import { assertPrivilegeOrAlert } from '@/utils/privilegeGate';
import { resolveKeyonPrivilegeIdentity } from '@/api/privilegesApi';
// CDA import enrichment: fetch structured fields from stored XML before InsertMedication.
import { fetchCdaMedicationImportFields } from '@/api/cdaApi';
import {
  buildCdaMedicationLink,
  mapCdaMedImportFields,
  medicationImportKey,
  resolveMedCodesFromCcdIds,
} from '@/utils/cdaMedImportMapper';

export default {
  name: 'cda-content-side-bar',
  components: {
    'togglable-caret-header': TogglableCaretHeader,
    'cda-visitable-item': CdaVisitableItem,
    'watch-button-cda': WatchButtonCda
  },
  props: [ 'itemInfo' ,'ready'],
  data() {
    return {
      kinds,
      types,
      sortMethod: 'kindAndDate',
      contents: this.cdaSideBarContentByKindAndDate,
      selectedItem: null,
      categories: [ kinds.E_PROCEDURE, kinds.PROCEDURE, kinds.E_MEASURE, kinds.MEASURE, kinds.E_LAB, kinds.LAB, kinds.E_DIAGNOSIS, kinds.DIAGNOSIS, kinds.E_MEDICATION, kinds.MEDICATION, kinds.E_VACCINE, kinds.VACCINE, kinds.E_ALLERGY, kinds.ALLERGY, kinds.E_OTHER, kinds.OTHER ],
      selectedDiagnoses: [],
      selectedMedications: [] // sidebar checkboxes for batch CDA import to Current Meds
    }
  },
  computed: {
    ...mapGetters('login/cda', {
      cdaSideBarContentByKindAndDate: 'getCdaSideBarContentKindAndDate',
      cdaSideBarContentByDateAndKind: 'getCdaSideBarContentGrouped',
      cdaIndex: 'getCdaIndex', // needed to resolve current CDA id for medication import API
    }),
    ...mapGetters('login', {
      allData: 'getAllData'
    }),
    patient() {
      return this.allData && this.allData.patient ? this.allData.patient : null;
    },
    // Resolve the open CDA document id so we can re-parse its XML during med import.
    currentCdaId() {
      const cdas = this.allData?.cdas;
      if (!cdas || this.cdaIndex === undefined || this.cdaIndex < 0) return null;
      const cda = cdas[this.cdaIndex];
      return cda?.id ?? null;
    },
    expanded() {
      // console.log(this.cdaSideBarContentByKindAndDate)
      if(this.$route.params.type && 
        ( this.$route.params.type === types.vaccination ||
          this.$route.params.type === types.diagnosis ||
          this.$route.params.type === types.allergy ||
          this.$route.params.type === types.medication ) )
        return true;
      else
        return false;
    }
  },
  beforeDestroy() {
    delete this.kinds;
    this.kinds = null;
    delete this.sortMethod;
    this.sortMethod = null;
    delete this.contents;
    this.contents = null;
  },
  methods: {
    onSelectionChanged(selectedItem) {
      this.selectedItem = selectedItem;
    },
    getHeaderByKind,

    cdaTextValue(...candidates) {
      for (const value of candidates) {
        if (value !== null && value !== undefined && String(value).trim() !== '') {
          return String(value).trim();
        }
      }
      return '';
    },

    cdaDateValue(value) {
      const text = this.cdaTextValue(value);
      if (!text) return '';
      const match = text.match(/^(\d{4}-\d{2}-\d{2})/);
      return match ? match[1] : text.substring(0, 10);
    },

    // MySQL date columns reject ''; use null when CDA has no date.
    cdaDateValueOrNull(value) {
      const date = this.cdaDateValue(value);
      return date || null;
    },

    // tswebhook InsertDiagnosis / InsertMedication call LogEphiAccess when these are set.
    ephiInsertFields() {
      const { accountnumber, unique_ID } = resolveKeyonPrivilegeIdentity(this.allData);
      return {
        accountnumber,
        subaccountnumber: unique_ID,
      };
    },

    buildDiagnosisInsertFromCdaItem(item, pid) {
      const diagCode = this.cdaTextValue(item.icd10, item.icd, item.code, item.value, item.desc);
      return {
        Diagnosis: {
          API_Meth: 'InsertDiagnosis',
          ordernumber: 0,
          diagnosis_type: 'Diagnosis',
          onset_exacerbation: '',
          diagnosisDate: this.cdaDateValue(item.lo) || null,
          endDate: null,
          diagControlRating: '',
          diagcode: diagCode,
          proccode: '',
          procShorthand: '',
          pid,
          status: 'Active',
          instruction: '',
          writer: this.cdaTextValue(this.allData?.manager?.name),
          ...this.ephiInsertFields(),
        }
      };
    },

    // Build InsertMedication payload; importFields come from cdaMedicationImport API when available.
    buildMedicationInsertFromCdaItem(item, pid, importFields = {}) {
      const medName = this.cdaTextValue(item.substance, item.desc, item.name);
      const shorthand = this.cdaTextValue(item.shorthand);
      const ccds = (this.allData && this.allData.ccds) || {};
      // Prefer backend-scanned codes, fall back to sidebar CCD code resolution.
      const codeFields = resolveMedCodesFromCcdIds(item.codes, ccds);
      const rxnorm = this.cdaTextValue(importFields.rxnorm, codeFields.rxnorm);
      const ndcCode = this.cdaTextValue(importFields.ndc, codeFields.ndc);
      // Map route, dose, and frequency from CDA XML into our medication form values.
      const mapped = mapCdaMedImportFields({
        ...importFields,
        instructions: importFields.instructions || item.instructions,
      });

      const instructionParts = [];
      const instructions = this.cdaTextValue(item.instructions);
      if (instructions) {
        instructionParts.push(instructions);
      }
      // Tag imports so Current Med can identify unordered CDA rows and offer Create Order.
      const combinedInstructions = instructionParts.length
        ? `[From CDA] ${instructionParts.join(' | ')}`
        : (medName ? `[From CDA] ${medName}` : '[From CDA]');

      return {
        MedicationInsert: {
          API_Meth: 'InsertMedication',
          patientID: pid,
          ordernumber: 0,
          medname: medName,
          shorthand,
          doseamount: mapped.doseAmount,
          doseUOM: mapped.doseUnit,
          frequency: mapped.frequency,
          diagcode: '',
          medRoute: mapped.route,
          altroute: '',
          instruction: combinedInstructions,
          medstrtdt: this.cdaDateValueOrNull(item.lo),
          medenddt: this.cdaDateValueOrNull(item.hi),
          changetype: '',
          durgclassification: '',
          prn: false,
          directionuse: '',
          additionalsettings: '',
          status: 'Active',
          writer: this.cdaTextValue(this.allData?.manager?.name),
          ndcnumber: ndcCode, // persisted on medications row via InsertMedication
          rxnorns: rxnorm,
          source: 'CDA', // tag unordered CDA imports in medications.source
          link: buildCdaMedicationLink(this.cdaIndex, item.id), // deep link back to this CDA med entry
          ...this.ephiInsertFields(),
        }
      };
    },

    onToggleSelection(payload) {
      // Track which CDA sidebar rows are checked for batch import.
      const { kind, item, checked } = payload || {};
      if (!item || typeof item.id === 'undefined') return;

      const key = String(item.id);
      const updateList = (list) => {
        const idx = list.findIndex(entry => String(entry.id) === key && entry.kind === kind);
        if (checked && idx === -1) {
          list.push({ id: key, kind, item });
        } else if (!checked && idx !== -1) {
          list.splice(idx, 1);
        }
      };

      if (kind === kinds.DIAGNOSIS || kind === kinds.E_DIAGNOSIS) {
        updateList(this.selectedDiagnoses);
      } else if (kind === kinds.MEDICATION || kind === kinds.E_MEDICATION) {
        updateList(this.selectedMedications);
      }
    },

    async importSelectedDiagnoses() {
      if (!assertPrivilegeOrAlert(PRIVILEGES.DIAGNOSIS_ADD,'You do not have permission to add diagnoses.')) {
        return;
      }
      if (!this.patient || !this.patient.externId || this.selectedDiagnoses.length === 0) return;

      const pid = this.patient.externId;
      let successCount = 0;
      let errorCount = 0;

      for (const entry of this.selectedDiagnoses) {
        const content = this.buildDiagnosisInsertFromCdaItem(entry.item, pid);

        try {
          const res = await axios.post(CURR_API + '/tswebhook.php', content, {
            headers: { 'Content-Type': 'application/json;' }
          });
          const data = res && res.data ? res.data : null;
          const result = data && (data.result || data.Result);
          if (result === 'Inserted' || result === 'inserted') {
            successCount += 1;
          } else {
            errorCount += 1;
            console.warn('InsertDiagnosis from CDA did not return success:', data);
          }
        } catch (e) {
          console.warn('Failed to import diagnosis from CDA:', e);
          errorCount += 1;
        }
      }

      if (successCount > 0) {
        alert(
          `Moved ${successCount} diagnosis${successCount > 1 ? 'es' : ''} to Current Diagnosis` +
            (errorCount > 0 ? ` (${errorCount} failed)` : '')
        );
      } else {
        alert('Unable to move selected diagnoses to Current Diagnosis. Please check the console for details.');
      }
      this.selectedDiagnoses = [];
    },

    async importSelectedMedications() {
      // Move checked CDA meds into Current Medications as unordered rows (order_number 0).
      if (!assertPrivilegeOrAlert(PRIVILEGES.MEDICATION_ADD_UNORDERED,'You do not have permission to add medications.')) {
        return;
      }
      if (!this.patient || !this.patient.externId || this.selectedMedications.length === 0) return;

      const pid = this.patient.externId;
      let successCount = 0;
      let errorCount = 0;
      let importFieldsByKey = {};

      // Batch-fetch route/dose/frequency/RxNorm/NDC from stored CDA XML before inserting rows.
      if (this.currentCdaId) {
        try {
          const items = this.selectedMedications.map((entry) => ({
            key: medicationImportKey(entry.item),
            htmlname: entry.item.htmlname,
            lo: entry.item.lo,
            hi: entry.item.hi,
          }));
          importFieldsByKey = await fetchCdaMedicationImportFields(this.currentCdaId, items);
        } catch (e) {
          // Non-fatal: still import with sidebar codes if the enrichment API fails.
          console.warn('Failed to load structured CDA medication fields; importing with available codes only:', e);
        }
      }

      for (const entry of this.selectedMedications) {
        const importFields = importFieldsByKey[medicationImportKey(entry.item)] || {};
        const content = this.buildMedicationInsertFromCdaItem(entry.item, pid, importFields);

        try {
          const res = await axios.post(CURR_API + '/tswebhook.php', content, {
            headers: { 'Content-Type': 'application/json;' }
          });
          const data = res && res.data ? res.data : null;
          if (data && (data.sqlresult === 'Inserted' || data.status === 'Success' || data.result === 'Inserted')) {
            successCount += 1;
          } else {
            errorCount += 1;
            console.warn('InsertMedication from CDA did not return clear success:', data);
          }
        } catch (e) {
          console.warn('Failed to import medication from CDA via InsertMedication:', e);
          errorCount += 1;
        }
      }

      if (successCount > 0) {
        alert(
          `Moved ${successCount} medication${successCount > 1 ? 's' : ''} to Current Medications` +
            (errorCount > 0 ? ` (${errorCount} failed)` : '')
        );
      } else {
        alert('Unable to move selected medications to Current Medications. Please check the console for details.');
      }
      this.selectedMedications = [];
    },

    sort: function () {
      // this.sidebarContent = this.sortMethod;
      switch (this.sortMethod) {
        case 'dateAndKind':
          this.contents = this.cdaSideBarContentByDateAndKind;
          break;
        case 'kindAndDate':
          this.contents = this.cdaSideBarContentByKindAndDate;
          break;
        default:
          this.contents = this.cdaSideBarContentByKindAndDate;
      }
    },
  }

}
</script>

<style scoped lang="scss">
  .kind {
    padding: 0.5rem 1.0rem;
    width: 100%;
    text-align: center;
    font-weight: bold;
    list-style: none;
  }
  .content-sidebar {
    height: 90vh;
    overflow: scroll;
  }
  .card-top {
    background-color: white;
      &:nth-child(odd) {
          background-color: rgba(0, 0, 0, 0.03);
      }
  }
  .card {
    width: 100%;
    background-color: transparent;

    .card-header {
      border-bottom: none;
      padding-left: 1.0rem;
      background-color: transparent;
      display: table;
    }
    .card-body {
      font-size: 0.9rem;
      color: lighten(#000, 20%);
      padding: 0;
      background-color: rgba(0, 0, 0, 0.03);
    }
  }

  .list-group-item {
    border: none;
    display: inline-flex;
    background-color: transparent;
    padding: 0;
    /*padding: 0;*/
    cursor: pointer;
    border-bottom: 1px solid darken(#fff, 15%);
    /*&:nth-child(odd) {*/
      /*background-color: rgba(0, 0, 0, 0.03);*/
    /*}*/
  }
  .header__link {
    white-space: normal;
    // width: 100%;
    display: table-cell;
    vertical-align: middle;
    

    &:hover {
      cursor: pointer;
    }
  }
  .form-group {
    font-size: 14px;
  }

</style>
